export default {
  courseType: {
    VKU1: "Verkehrskundekurs 1",
    VKU2: "Verkehrskundekurs 2",
    VKU3: "Verkehrskundekurs 3",
    VKU4: "Verkehrskundekurs 4",
    FirstAid: "Nothelferkurs",
    MotorcycleTraining: "Motorrad Weiterbildungskurs",
    DrivingAttendant: "Fahrbegleiterkurs",
    PGS1: "Grundkurs 1-3",
    PGS2: "Grundkurs 1-3",
    PGS3: "Grundkurs 2a",
    PGS4: "Grundkurs 3"
  },
  shortMonths: {
    january: "Januar",
    february: "Februar",
    march: "März",
    april: "April",
    may: "Mai",
    june: "Juni",
    july: "Juli",
    august: "August",
    september: "September",
    october: "Oktober",
    november: "November",
    december: "Dezember"
  },
  daysShort: {
    'monday': 'Mo',
    'tuesday': 'Di',
    'wednesday': 'Mi',
    'thursday': 'Do',
    'friday': 'Fr',
    'saturday': 'Sa',
    'sunday': 'So',
  },
  vkuPriceTitle: {
    bold: 'Preis: CHF 260.00',
    note: 'inkl. Kursmaterial'
  },
  pgsPrice: {
    label: 'Kurskosten:',
    price: 'CHF 210.00',
    note1: 'Grundkurs 1',
    note2: 'Grundkurs 2',
    note3: 'Grundkurs 3'
  },
  vkuNote: {
    note: '(4 Kursteile) und Gutschein CHF 40.00 für den obligatorischen WAB-Kurs in Erstfeld sowie gratis TCS-Mitgliedschaft und TCS-Verkehrsrechtschutz für ein Jahr.'
  },
  infoMessage: {
    pgs3: 'Dieser Kurs findet in kategorien-einheitlichen Gruppen statt. Gerne vereinbaren wir im Grundkurs 1 (oder falls ihr LFA zeitnah abläuft telefonisch unter 079 743 48 12) ein geeignetes Datum.',
    pgs3_caruso: 'Dieser Kurs findet in kategorien-einheitlichen Gruppen statt. Gerne vereinbaren wir im Grundkurs 1 (oder falls ihr LFA zeitnah abläuft telefonisch unter 076 621 88 15) ein geeignetes Datum.',
    pgs3_info: 'Grundkurs 3',
    pgsTitle3Parts: 'Grundkurs (für Motorräder ab 60ccm)',
    pgsTitle2Parts: 'Grundkurs (für alle Kategorien)',
    vku1Completed: 'Bitte beachten Sie, dass Sie mit dem VKU 1 starten müssen. Drücken Sie auf Abbrechen, falls Sie den VKU 1 noch nicht absolviert haben.',
    language: "",
    languageInfo: 'Sprache',
    location: "Ort",
    instructor: "Kursleiter",
    enterInfos: "Bitte geben Sie Ihre Kontaktdaten ein",
    whereIsLearnersPermitNumber: "Wo steht Ihr FABER-PIN?",
    noCoursesTitle: "Technische Störung",
    noCourses: "Eine Anmeldung ist demzufolge zur Zeit nur telefonisch möglich.<br/>Bitte kontaktieren Sie Sven Meier <br/> unter <a href='tel:0796773890' style='color: #E91E63; white-space: nowrap;'>079 677 38 90</a>.",
    day: "Tag",
    month: "Monat",
    year: "Jahr",
    firstName: "Vorname",
    lastName: "Nachname",
    street: "Strasse",
    postCode: "PLZ",
    city: "Ort",
    phoneNumber: "Telefonnummer",
    email: "E-Mail",
    birthdate: "Geburtsdatum",
    booking: 'Zur Anmeldung',
    back: 'Zurück',
    motorcycleCategory: "Motorrad Lizenz Kategorie",
    continue: "Weiter",
    learnersPermitNumber: "FABER-PIN",
    requiringInfos: "Wir benötigen nur noch ein paar Informationen.",
    byRegistering: "Mit der Anmeldung akzeptieren Sie die",
    termsOfService: "AGB",
    courseLeft: 'frei',
    coursesFree: "Plätze frei",
    coursesFree_zero: "Ausgebucht",
    coursesFree_singular: "Platz frei",
    courseBooked: "Gebucht",
    signUp: "Anmelden",
    alreadyBooked: 'Ich habe den VKU Kurs',
    alreadyBooked2: 'bereits absolviert oder möchte mich zu einem späteren Zeitpunkt für diesen Kursteil anmelden.',
    pgsPart2and3: `
      Sofern Sie die Kategorie A1 vor dem 01.01.2021 absolviert haben und Ihr Lernfahrausweis für das Erlangen der Kategorie A eine vorgeschriebene Stundenzahl von 4 aufweist, vereinbaren Sie mit uns ein geeignetes Kursdatum für den Grundkurs 3.
      <br/><br/><strong>Ruedi Huwiler</strong>
      <br/><a href="mailto:ruedi.huwiler@verkehrsschule.ch" style="color: #E31B1F; white-space: nowrap;">ruedi.huwiler@verkehrsschule.ch</a> 
      <br/><a href="tel:+41797434812" style="color: #E31B1F; white-space: nowrap;">079 743 48 12</a>
      <br/><br/><strong>Giovanni Caruso</strong>
      <br/><a href="mailto:giovanni.caruso@verkehrsschule.ch" style="color: #E31B1F; white-space: nowrap;">giovanni.caruso@verkehrsschule.ch</a> 
      <br/><a href="tel:+41766218815" style="color: #E31B1F; white-space: nowrap;">076 621 88 15</a>
      <br/><br/>Besten Dank. Wir freuen uns auf einen interessanten und lehrreichen Kurs mit Ihnen.
    `,
    pgsPart2and3Sven: `
      Sofern Sie die Kategorie A1 vor dem 01.01.2021 absolviert haben und Ihr Lernfahrausweis für das Erlangen der Kategorie A eine vorgeschriebene Stundenzahl von 4 aufweist, vereinbaren Sie mit uns ein geeignetes Kursdatum für den Grundkurs 3.
      <br/><br/><strong>Ruedi Huwiler</strong>
      <br/><a href="mailto:ruedi.huwiler@verkehrsschule.ch" style="color: #E31B1F; white-space: nowrap;">ruedi.huwiler@verkehrsschule.ch</a> 
      <br/><a href="tel:+41797434812" style="color: #E31B1F; white-space: nowrap;">079 743 48 12</a>
    <br/><br/>Besten Dank. Wir freuen uns auf einen interessanten und lehrreichen Kurs mit Ihnen.
    `,
    pgsPart2and3Moos: `
    Sofern Sie die Kategorie A1 vor dem 01.01.2021 absolviert haben und Ihr Lernfahrausweis für das Erlangen der Kategorie A eine vorgeschriebene Stundenzahl von 4 aufweist, vereinbaren Sie mit uns ein geeignetes Kursdatum für den Grundkurs 3.
    <br/><br/><strong>Giovanni Caruso</strong>
    <br/><a href="mailto:giovanni.caruso@verkehrsschule.ch" style="color: #E31B1F; white-space: nowrap;">giovanni.caruso@verkehrsschule.ch</a> 
    <br/><a href="tel:+41766218815" style="color: #E31B1F; white-space: nowrap;">076 621 88 15</a>
    <br/><br/>Besten Dank. Wir freuen uns auf einen interessanten und lehrreichen Kurs mit Ihnen.
  `,
    vku: "Haben Sie den VKU 1 bereits besucht / angemeldet? Bevor Sie an VKU 2-4 teilnehmen können, müssen Sie zuerst den VKU 1 absolviert haben.",
    pgs: `
      Sie haben den Lernfahrausweis noch nicht? Schicken Sie bitte Ihre Kontaktdaten an
      <a href="mailto:info@verkehrsschule.ch" style="color: #E91E63;">info@verkehrsschule.ch</a>
      und wir werden das nötige veranlassen.
    `
  },
  successMessage: {
    VKUPart1: `
      <h2>Vielen Dank.</h2>
      Wir haben Ihre <strong>Reservation</strong> erhalten und freuen uns auf einen interessanten und lehrreichen Kurs mit Ihnen. <br>
      <br>
    `,
    ReservationUntil: `
      Ihr Kursplatz bleibt bis 15 Minuten vor Kursbeginn reserviert. <br>
      <br>
    `,
    VKUPart2: `
      Eine Bestätigung der Reservation senden wir Ihnen per Mail zu. Sollten Sie nicht innerhalb von einer Stunde eine Reservationsbestätigung erhalten, gehen Sie bitte wie folgt vor: Prüfen Sie zuerst, ob die E-Mail in Ihrem Spam Ordner gelandet ist.
      Ist dies nicht der Fall, wenden Sie sich bitte an <strong><a href="mailto:info@verkehrsschule.ch">info@verkehrsschule.ch</a></strong>. <br>
      <br>
      Freundliche Grüsse <br>
      Verkehrsschule Zug <br>
    `,
    FirstAidPart1: `
      <h2>Vielen Dank.</h2>
      Wir haben Ihre <strong>Anmeldung</strong> für den
    `,
    FirstAidPart2: `
      erhalten und freuen uns auf einen interessanten und lehrreichen Kurs mit Ihnen. <br>
      <br>
      Eine Bestätigung der Anmeldung senden wir Ihnen per Post zu.<br>
      <br>
      Freundliche Grüsse <br>
      Verkehrsschule Zug <br>
    `,
    PGSPart1: `
      <h2>Vielen Dank.</h2>
      Wir haben Ihre <strong>Anmeldung</strong> für den
    `,
    PGSPart2: `
      erhalten und freuen uns auf einen interessanten und lehrreichen Kurs mit Ihnen. <br>
      <br>
      Eine Bestätigung der Anmeldung senden wir Ihnen per Post zu.<br>
      <br>
      Freundliche Grüsse <br>
      Verkehrsschule Zug <br>
    `
  },
  language: {
    de: 'Deutsch',
    en: 'English'
  },
  language_long: {
    de: 'Kurssprache: Deutsch',
    en: 'Kurssprache: English'
  },
  errorMessage: {
    InternalServerError: "Hoppla. Es ist ein Problem aufgetreten. Bitte wenden Sie sich an info@verkehrsschule.ch",
    MissingFirstName: "Bitte geben Sie Ihren Vornamen ein",
    MissingLastName: "Bitte geben Sie Ihren Nachnamen ein",
    MissingStreet: "Bitte geben Sie Ihre Strasse ein",
    MissingPostCode: "Bitte geben Sie Ihre PLZ ein",
    MissingCity: "Bitte geben Sie Ihr Ort ein",
    MissingTel: "Bitte geben Sie Ihre Telefonnummer ein",
    NoIdNumber: "Bitte geben Sie Ihren FABER-PIN ein",
    MissingMail: "Bitte geben Sie eine gültige E-Mail ein",
    MissingBirthdate: "Bitte geben Sie ein gültiges Geburtsdatum ein",
    200: "Ihr FABER-PIN wurde nicht gefunden.",
    201: "Ihr eingegebenes Geburtsdatum stimmt nicht mit Ihrem FABER-PIN überein.",
    202: "Sie wurden bereits zu diesem Kurs zugewiesen.",
    203: "Es hat zu wenig Plätze im Kurs.",
    204: "Sie haben zum gleichen Zeitpunkt schon einen Kurs.",
    205: "Ihr Lernfahrausweis ist am Kurszeitpunkt abgelaufen.",
    206: "Hoppla. Es ist ein Problem aufgetreten. Bitte wenden Sie sich an info@verkehrsschule.ch",
    300: "Sie haben bereits an diesem Tag einen Kurs gebucht.",
    301: "Dieser Kurs kann nicht gebucht werden. Bitte wählen Sie einen Kurs aus, welcher erst nach Ihrem bereits gebuchten VKU-1 stattfindet.",
    302: "Sie haben sich für diesen Kursteil bereits eingetragen."
  }
};
